import {Injectable} from "@angular/core"
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpEventType, HttpErrorResponse } from "@angular/common/http"
import {Observable, of, throwError} from "rxjs"
import {catchError, filter, tap} from "rxjs/operators"
import {AuthenticationService} from "../../_services/user/authentication/authentication.service"
import {SnackbarService} from "../../_services/shared/snackbar.service"
import {ConfigService} from "src/app/_services/config.service"
import {ISummarizedApiError} from "../../_interfaces/ISummarizedApiError"
import {EInterceptorOptionsHTTPHeaders} from "./EInterceptorOptionsHTTPHeaders"

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private snackbarService: SnackbarService, private environment: ConfigService) {}
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.headers.get(EInterceptorOptionsHTTPHeaders.SuppressErrorInterceptor)) {
			return next.handle(request)
		}
		return next.handle(request).pipe(
			tap(
				(next) => {}, // do nothing if it's a normal successful emission
				(errorResponse: HttpErrorResponse) => {
					// console.log("ERR", errorResponse)
					let message = errorResponse?.error?.message
					if (!message) {
						message = recursivePropertySearch(errorResponse, "message")
					}
					const apiErrorDisplay: ISummarizedApiError = {
						serviceName: this.calledFrom(request),
						statusCode: `${errorResponse.status}`,
						errorMessage: message,
					}
					this.snackbarService.addError(apiErrorDisplay)
				},
			),
			//   return throwError(of(err)).pipe(
			//     tap((err)=> {console.log(err)})
			//   )
			//   // return throwError(err);
			// }
			// )
		)
	}

	calledFrom(req: HttpRequest<any>): string {
		const url = req.url
		var callingSvc
		url.includes(this.environment.femsEndpoint) ? (callingSvc = "FEMS(external)") : null
		url.includes(this.environment.analysisServiceApi.baseUrl) ? (callingSvc = "Analysis Service") : null
		url.includes(this.environment.caseApi.baseUrl) ? (callingSvc = "Case Service") : null
		url.includes(this.environment.irwinApi.baseUrl) ? (callingSvc = "IRWIN") : null
		url.includes(this.environment.userApi.baseUrl) ? (callingSvc = "User Service") : null
		url.includes(this.environment.commonUtilityApi.baseUrl) ? (callingSvc = "Utility Service") : null
		url.includes(this.environment.decisionApi.baseUrl) ? (callingSvc = "Decision Service") : null
		return callingSvc
	}
}

export function recursivePropertySearch(object, key) {
	var value
	Object.keys(object).some(function (k) {
		if (k === key) {
			value = object[k]
			return true
		}
		if (object[k] && typeof object[k] === "object") {
			value = recursivePropertySearch(object[k], key)
			return value !== undefined
		}
	})
	return value
}
